import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
/** Represents the component for filtering by similar conversations. */
export const ConversationsTableRowMenuFilter = ({ user, isAssignee, toggleDropdown, }) => {
    const { replaceParams } = useAppSearchParams('/conversations');
    /** Handles filtering the conversations by the user. */
    const handleClick = useCallback(() => {
        toggleDropdown();
        replaceParams({ [isAssignee ? 'agent' : 'requester']: user.id });
        if (isAssignee) {
            analytics.conversationsFilterAgentClicked({
                id: user.id,
            });
        }
        else {
            analytics.conversationsFilterContactClicked({
                id: user.id,
            });
        }
    }, [isAssignee, replaceParams, toggleDropdown, user.id]);
    return (_jsx(ButtonList.Item, Object.assign({ onClick: handleClick }, { children: "Filter conversations" })));
};
